import { useState } from "react";
import Fade from "../../components/Fade";
import LogoFooter from "../../components/LogoFooter";
import { useNavigate, useLocation } from "react-router-dom";
import DelayedLinkWithFadeout from "../../components/utils/DelayedLinkWithFadeout";

export default function Comentario() {
  const [observacao, setObservacao] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const handleEnviar = () => {
    const dadosPesquisa = JSON.parse(localStorage.getItem("dadosPesquisa"));
    dadosPesquisa.comentario = observacao;
    localStorage.setItem("dadosPesquisa", JSON.stringify(dadosPesquisa));
    navigate("/conclusao");
  };

  const handleVoltar = () => {
    navigate(-1);
  };

  return (
    <>
      <Fade>
        <div className="w-full min-h-screen flex flex-col justify-between px-12 pt-12 pb-4">
          <div className="flex flex-col flex-1">
            <div className="mb-12">
              <h1 className="text-6xl font-bold text-deepBlue">
                Pesquisa de avaliação do serviço
              </h1>
            </div>

            <div className="mb-12 max-w-7xl">
              <p className="text-2xl text-deepBlue leading-relaxed">
                Reservamos este campo não obrigatório para comentários gerais.
              </p>
            </div>

            <div className="relative max-w-7xl flex justify-center">
              <textarea
                value={observacao}
                onChange={(e) => setObservacao(e.target.value)}
                className="p-6 w-full text-2xl bg-white border-2 border-[#c6d3df] rounded-3xl h-40 focus:outline-none focus:ring-2 focus:ring-deepBlue placeholder:text-black"
                placeholder="Toque aqui para deixar seu comentário..."
              />
            </div>
          </div>

          <div className="w-full flex items-center justify-between">
            <div className="flex gap-6 items-center">
              <DelayedLinkWithFadeout to="/">
                <button className="min-w-[200px] py-4 bg-blue-100 text-deepBlue px-12 rounded-2xl text-3xl font-semibold">
                  Cancelar
                </button>
              </DelayedLinkWithFadeout>
              <button
                onClick={handleVoltar}
                className="min-w-[200px] py-4 border-2 border-deepBlue text-deepBlue px-12 rounded-2xl text-3xl font-semibold transition"
              >
                Voltar
              </button>
              <button
                onClick={handleEnviar}
                className="min-w-[200px] py-4 bg-deepBlue text-white px-12 rounded-2xl text-3xl font-semibold hover:bg-opacity-90 transition"
              >
                Enviar
              </button>
            </div>

            <div className="p-6">
              <LogoFooter />
            </div>
          </div>
        </div>
      </Fade>
    </>
  );
}
